function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12.001C0 5.37419 5.37321 0.000976562 12 0.000976562C18.6268 0.000976562 24 5.37419 24 12.001C24 18.6278 18.6268 24.001 12 24.001C5.37321 24.001 0 18.6278 0 12.001ZM2.03571 12.001C2.03571 17.5028 6.49821 21.9653 12 21.9653C17.5018 21.9653 21.9643 17.5028 21.9643 12.001C21.9643 6.49919 17.5018 2.03669 12 2.03669C6.49821 2.03669 2.03571 6.49919 2.03571 12.001ZM11.0905 8.19583C10.8493 7.95471 10.7139 7.62768 10.7139 7.28669C10.7139 6.9457 10.8493 6.61867 11.0905 6.37755C11.3316 6.13644 11.6586 6.00098 11.9996 6.00098C12.3406 6.00098 12.6676 6.13644 12.9087 6.37755C13.1498 6.61867 13.2853 6.9457 13.2853 7.28669C13.2853 7.62768 13.1498 7.95471 12.9087 8.19583C12.6676 8.43695 12.3406 8.5724 11.9996 8.5724C11.6586 8.5724 11.3316 8.43695 11.0905 8.19583ZM11.1425 10.501C11.1425 10.3831 11.2389 10.2867 11.3567 10.2867H12.6425C12.7603 10.2867 12.8567 10.3831 12.8567 10.501V17.7867C12.8567 17.9045 12.7603 18.001 12.6425 18.001H11.3567C11.2389 18.001 11.1425 17.9045 11.1425 17.7867V10.501Z",
  fill: "#0D53FC"
});

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f026be5b.svg";
export { ForwardRef as ReactComponent };